// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XoBn","question":"styles_question__Dq9DM","inputVisibleButton":"styles_inputVisibleButton__2gAVb","note":"styles_note__2zA17"};